import React from "react";
import SkeletonBox from "./skeleton";

const FdpageSkeleton = () => {
    const renderSkeletonPairs = (pairs: string[][]) =>
        pairs.map((pair, idx) => (
            <div
                key={idx}
                className="mt-8 flex flex-row justify-between gap-2 md:flex-row md:gap-20"
            >
                <SkeletonBox classname={`${pair[0]} rounded-full`} />
                <SkeletonBox classname={`${pair[1]} rounded-full`} />
            </div>
        ));

    return (
        <div className="h-auto w-full self-start px-6">
            <div className="mx-auto flex flex-col gap-8 px-0 md:w-[1220px] md:flex-row md:gap-16 md:px-0 md:py-s9 md:pb-10 md:pt-10">
                <div>
                    <div className="hidden h-[148px] w-full gap-4 rounded-3xl border border-gray-200 p-s9 md:flex md:w-[854px]">
                        <div className="gap-4 md:flex-row md:gap-80">
                            <SkeletonBox classname="h-[84px] md:w-[84px]" />
                        </div>
                        <div className="mt-2">
                            <SkeletonBox classname="h-[31px] md:w-[340px]" />
                            <div className="flex gap-4">
                                <SkeletonBox classname="h-[29px] md:w-[125px] mt-2" />
                                <SkeletonBox classname="h-[29px] md:w-[125px] mt-2" />
                            </div>
                        </div>
                        <div className="ml-20 flex flex-col gap-2">
                            <SkeletonBox classname="h-[29px] md:w-[125px] mt-2" />
                            <SkeletonBox classname="h-[29px] md:w-[125px] mt-2" />
                        </div>
                        <div className="flex flex-col gap-2">
                            <SkeletonBox classname="h-[29px] md:w-[125px] mt-2" />
                            <SkeletonBox classname="h-[29px] md:w-[125px] mt-2" />
                        </div>
                    </div>
                    <div className="flex h-[148px] w-full flex-col gap-4 md:hidden mb-40">
                        <div className="gap-4">
                            <SkeletonBox classname="h-[84px] w-[84px]" />
                        </div>
                        <div className="mt-2">
                            <div className="flex gap-4">
                                <SkeletonBox classname="h-[20px] w-[125px] mt-2" />
                                <SkeletonBox classname="h-[20px] w-[90px] mt-2" />
                            </div>
                        </div>
                        <div className="flex justify-between">
                            <div>
                                <SkeletonBox classname="h-[20px] w-[125px] mt-2" />
                                <SkeletonBox classname="h-[20px] w-[90px] mt-2" />
                            </div>
                            <div>
                                <SkeletonBox classname="h-[20px] w-[125px] mt-2" />
                                <SkeletonBox classname="h-[20px] w-[90px] mt-2" />
                            </div>
                        </div>
                    </div>
                    <SkeletonBox classname="md:w-[340px] md:h-[60px] w-[220px] h-[36px] mb-6 md:mb-s11 mt-24" />
                    {Array.from({ length: 3 }).map((_, index) => (
                        <div className="mt-8" key={index}>
                            <SkeletonBox classname="w-[200px] h-[28px]" />
                            <SkeletonBox classname="md:w-[854px] h-[20px] mt-2" />
                            <SkeletonBox classname="md:w-[854px] h-[20px] mt-2" />
                            <SkeletonBox classname="md:w-[460px] w-[220px] h-[20px] mt-2" />
                        </div>
                    ))}
                    <div className="mt-24">
                        <div className="grid grid-cols-1 gap-8 md:grid-cols-2">
                            {Array.from({ length: 4 }).map((_, index) => (
                                <div key={index}>
                                    <SkeletonBox classname="w-[72px] h-[72px]" />
                                    <SkeletonBox classname="w-[280px] h-[26px] mt-8" />
                                    <SkeletonBox classname="md:w-[400px] h-[13px] mt-4" />
                                    <SkeletonBox classname="md:w-[400px] h-[13px] mt-2" />
                                    <SkeletonBox classname="w-[300px] h-[13px] mt-2" />
                                </div>
                            ))}
                        </div>
                    </div>
                    <div className="mt-16 flex flex-col gap-4 p-s9 pl-0 pr-0 md:flex-row md:gap-4 md:py-0 md:pb-10">
                        <div className="h-auto w-full rounded-3xl border border-gray-200 p-s9 md:w-[854px]">
                            <div className="item flex flex-row justify-between gap-2">
                                <SkeletonBox classname="h-[17px] w-[88px] rounded-full" />
                                <SkeletonBox classname="h-[17px] w-[52px] rounded-full" />
                            </div>
                            <div className="mt-4 border-b border-dotted border-gray-400" />
                            <SkeletonBox classname="h-[10px] w-[143px] rounded-full mt-8" />
                            <div className="item flex flex-col justify-between gap-2 md:flex-row">
                                <SkeletonBox classname="h-[23px] md:w-[468px] w-[200px] rounded-full mt-2 text-center" />
                                <SkeletonBox classname="h-[37px] w-[132px] rounded-full mt-2" />
                            </div>
                            <SkeletonBox classname="hidden md:block h-[10px] w-[143px] rounded-full" />
                        </div>
                    </div>
                </div>

                <div className="hidden w-full flex-col gap-4 md:flex md:w-[299px]">
                    <div className="h-auto rounded-3xl border border-gray-200 p-s9">
                        <SkeletonBox classname="h-[25px] w-[210px] rounded-full" />
                        <div className="mt-4 border-b border-dotted border-gray-400" />
                        {renderSkeletonPairs([
                            ["h-[13px] w-[111px]", "h-[13px] w-[64px]"],
                            ["h-[13px] w-[142px]", "h-[13px] w-[64px]"],
                            ["h-[13px] w-[111px]", "h-[13px] w-[64px]"],
                            ["h-[13px] w-[111px]", "h-[13px] w-[64px]"],
                        ])}
                        <div className="mt-8 border-b border-dotted border-gray-400" />
                        <div className="mt-8 flex flex-row justify-between gap-2 md:gap-20">
                            <SkeletonBox classname="h-[13px] w-[111px] rounded-full" />
                            <SkeletonBox classname="h-[13px] w-[64px] rounded-full" />
                        </div>
                        <SkeletonBox classname="h-[49px] w-[255px] rounded-full mt-4 text-center" />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default FdpageSkeleton;
